
export enum ApiThrottlingTierCd {
	FIFTY_K_PER_MIN = 'FiftyKPerMin',
	TEN_K_PER_MIN = 'TenKPerMin',
	TWENTY_K_PER_MIN = 'TwentyKPerMin',
	UNLIMITED = 'Unlimited'}

